import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { REFERENCIALS_URL, useGetReferentialsAsync } from '@/features/shared/apis';

import { GetPaymentMethodsReferential } from '../types';

export const usePaymentMethodOptions = () => {
  const { t } = useTranslation('borderCrossingRORO_onBoarding');
  const { data: paymentMethodData, isLoading: isGetPaymentMethodLoading } =
    useGetReferentialsAsync<GetPaymentMethodsReferential>(REFERENCIALS_URL.PAYMENT_METHOD);

  const paymentMethodOptions = useMemo(
    () =>
      (paymentMethodData?.paymentMethods ?? []).map(({ id, translationKey }) => ({
        label: t(
          `borderCrossingRORO.onBoarding.subscribeAdditionnalInformation.form.paymentMethods.${translationKey}.label`,
        ),
        value: id,
      })),
    [paymentMethodData?.paymentMethods, t],
  );

  return {
    isGetPaymentMethodLoading,
    paymentMethodOptions,
  };
};
